import styled from 'styled-components';

const ContentStyle = styled.div`
	--heroSVGDistance: var(--sp6x);
	--iconSize: var(--sp4x);
	--heroTitleMarginT: var(--sp3x);
	--heroTitleMarginB: var(--sp5x);
	--marginB: var(--sp3x);
	--infoMarginT: var(--sp6x);
	--infoMarginB: 0;
	--colGap: var(--sp4x);
	--rowGap: var(--sp6x);
	--gap: var(--sp1-5x);
	--sizeIcon: var(--sp4x);

	--distanceButton: var(--sp6x);
	--padInfoWrap: var(--sp7x);

	padding-top: calc(var(--sectionDistance) / 2);

	.wrapper-infos {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: var(--padInfoWrap) 0;

		&.center {
			justify-content: center;
		}
	}

	.hero-svg-block {
		margin-bottom: var(--heroSVGDistance);
	}

	.hero-title {
		margin: var(--heroTitleMarginT) 0 var(--heroTitleMarginB);
	}

	.additional-info-wrapper {
		display: grid;
		margin-top: var(--infoMarginT);
		margin-bottom: var(--infoMarginB);
		grid-template-columns: 1fr 1fr;
		row-gap: var(--rowGap);
		column-gap: var(--colGap);

		.additional-info-top-wrapper {
			display: flex;
			align-items: center;
			gap: var(--gap);
			margin-bottom: var(--marginB);

			svg {
				width: var(--iconSize);
				height: var(--iconSize);
			}
		}
	}

	.link-info-wrapper {
		margin-top: var(--distanceButton);
	}

	.button-wrapper {
		margin-bottom: var(--sp3x);

		.btn {
			width: 100%;
		}
	}

	.info-wrapper-button {
		background-color: var(--green100);
		padding: var(--sp1-5x) var(--sp2x);
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: var(--sp4x);

		.icon {
			font-size: var(--sizeIcon);
			margin-right: var(--sp1-5x);
		}

		.link-contact {
			text-transform: lowercase;
			text-decoration: underline;
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--heroSVGDistance: var(--sp5x);
		--heroTitleMarginB: var(--sp4x);
		--infoMarginT: var(--sp5x);
		--rowGap: var(--sp4x);
		--gap: var(--sp1x);
		--marginB: var(--sp1-5x);
		--distanceButton: var(--sp5x);
		--padInfoWrap: var(--sp6x);
		--sizeIcon: 28px;
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--heroSVGDistance: var(--sp4x);
		--heroTitleMarginT: var(--sp2x);
		--heroTitleMarginB: var(--sp3x);
		--infoMarginT: var(--sp4x);
		--colGap: var(--sp2x);
		--rowGap: var(--sp3x);
		--iconSize: var(--sp3x);
		--distanceButton: var(--sp4x);
		--padInfoWrap: var(--sp5x);
		--marginB: var(--sp1x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--heroSVGDistance: var(--sp3x);

		--distanceButton: var(--sp4x);
		--padInfoWrap: var(--sp3x);
		--sizeIcon: var(--sp3x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--heroSVGDistance: var(--sp3x);

		--distanceButton: var(--sp4x);
		--padInfoWrap: var(--sp3x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--heroSVGDistance: var(--sp2x);
		--iconSize: var(--sp2-5x);
		--heroTitleMarginT: var(--sp1x);
		--heroTitleMarginB: var(--sp2x);

		--distanceButton: var(--sp4x);
		--padInfoWrap: var(--sp3x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--heroSVGDistance: var(--sp2x);
		--heroTitleMarginT: var(--sp1-5x);
		--infoMarginB: var(--sp5x);
		--rowGap: var(--sp4x);

		--distanceButton: 0;
		--padInfoWrap: 0;

		.wrapper-infos {
			padding-top: var(--sp4x);
		}
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--heroSVGDistance: var(--sp2x);
		--infoMarginT: var(--sp4x);
		--infoMarginB: var(--sp4x);
		--rowGap: var(--sp3x);

		.additional-info-wrapper {
			grid-template-columns: 1fr;
		}
	}
`;

export default ContentStyle;
